import appConfig from '~/config/app'
import useGetCurriculumCountryCodeForURL, {
  getCurriculumCountryCodeWithGradePrefix,
  useGetInCurriculumV2,
} from '~/curriculum/hooks/useGetCurriculumCountryCode'
import useSsrSafeValue from '~/hooks/useSsrSafeValue'
import ROUTES from '~/shared/constants/routes.const'

export function getSelectGradePageRoute(config: {
  isOnboarding?: boolean
  isCurriculumV2?: boolean
  countryCodeWithGradePrefix: string
}): string {
  if (config?.isCurriculumV2 && config?.isOnboarding) {
    return `${ROUTES.ONBOARDING}/v2/${config.countryCodeWithGradePrefix}/select-grade`
  }
  if (config?.isCurriculumV2) {
    return `${ROUTES.CURRICULUM}/v2/${config.countryCodeWithGradePrefix}/select-grade`
  }
  return config?.isOnboarding
    ? `${ROUTES.ONBOARDING_SELECT_GRADE}/${config.countryCodeWithGradePrefix}`
    : `${ROUTES.BOOTCAMP_SELECT_GRADE}/${config.countryCodeWithGradePrefix}`
}

export default function useGetGradePageRoute(config?: {
  isOnboarding?: boolean
  specificCountryCode?: string
  isV2?: boolean
}): string {
  const countryCodeWithGradePrefix = useGetCurriculumCountryCodeForURL(config?.specificCountryCode)
  const isCurriculumV2User = useGetInCurriculumV2()
  const isCurriculumV2 = config?.isV2 ?? isCurriculumV2User
  return getSelectGradePageRoute({ ...config, countryCodeWithGradePrefix, isCurriculumV2 })
}

// The route the server renders: it has no `curriculumCountry` cookie and no client-side v2 flag.
export function getServerGradePageRoute(config?: { isOnboarding?: boolean; specificCountryCode?: string }): string {
  return getSelectGradePageRoute({
    ...config,
    countryCodeWithGradePrefix: getCurriculumCountryCodeWithGradePrefix(config?.specificCountryCode ?? ''),
    isCurriculumV2: appConfig.isSchoolPlatform,
  })
}

// Use for rendered hrefs only. Redirects (useRedirectV2UserToGradeOverview) must keep
// useGetGradePageRoute — they fire on mount and need the real country code immediately.
export function useGetGradePageRouteForLink(config?: {
  isOnboarding?: boolean
  specificCountryCode?: string
  isV2?: boolean
}): string {
  const route = useGetGradePageRoute(config)
  return useSsrSafeValue(getServerGradePageRoute(config), route)
}
